import get from 'lodash/get';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withHandlers from 'recompose/withHandlers';
import {formDataManager} from 'hoc/formDataManager';
import ChangeEmailModal from './ChangeEmailModal';
import config from './changeEmailFormConfig';
import {submitChangeEmailAction, endChangeEmailAction} from 'pages/UserManagement/actions';

const mapStateToProps = state => {
  const {changingEmail, changeEmailSubmitted, currentUserId, currentUser} = state.userManagement;
  return {
    userId: currentUserId,
    email: get(currentUser, 'email', null),
    modalOpen: changingEmail,
    changingEmail: changeEmailSubmitted
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  changeEmail: submitChangeEmailAction,
  handleClose: endChangeEmailAction
}, dispatch);

const ChangeEmailModalContainer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onSaveData: props => data => props.changeEmail(Number(props.userId), data.newEmail)
  }),
  formDataManager({email: '', newEmail: '' }, config),
  lifecycle({
    componentWillReceiveProps(nextProps) {

      // hack to get current email into the form.
      this.props.formData.email = this.props.email;
      const modalWillClose = this.props.modalOpen && !nextProps.modalOpen;
      if (modalWillClose) {
        this.props.reset();
      }
    }
  })
)(ChangeEmailModal);

export default ChangeEmailModalContainer;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/modals/ChangeEmailModal/ChangeEmailModalContainer.js